import * as React from "react";
function isDialogHistoryEntryOnTop() {
    var _a;
    const state = window.history.state;
    return typeof state === "object" && state !== null && ((_a = Object.getOwnPropertyDescriptor(state, "dialogBackButton")) === null || _a === void 0 ? void 0 : _a.value) === true;
}
export function useDialogBackButton(open, onClose) {
    const stateRef = React.useRef({ pushed: false, popped: false, cleanupTimer: null });
    React.useEffect(() => {
        if (!open)
            return;
        if (stateRef.current.cleanupTimer !== null) {
            window.clearTimeout(stateRef.current.cleanupTimer);
            stateRef.current = { pushed: true, popped: false, cleanupTimer: null };
        }
        else {
            stateRef.current = { pushed: true, popped: false, cleanupTimer: null };
            window.history.pushState({ dialogBackButton: true }, "");
        }
        const handlePopState = () => {
            if (!stateRef.current.pushed || stateRef.current.popped)
                return;
            stateRef.current.popped = true;
            onClose();
        };
        window.addEventListener("popstate", handlePopState, { once: true });
        return () => {
            window.removeEventListener("popstate", handlePopState);
            if (stateRef.current.pushed && !stateRef.current.popped) {
                stateRef.current.popped = true;
                stateRef.current.cleanupTimer = window.setTimeout(() => {
                    stateRef.current.cleanupTimer = null;
                    if (isDialogHistoryEntryOnTop()) {
                        window.history.back();
                    }
                }, 0);
            }
        };
    }, [open, onClose]);
}
